/** Offset from the cursor to the preferred tooltip corner. */
export const GANTT_TOOLTIP_CURSOR_OFFSET = 14;
/** Minimum gap between the tooltip and the viewport edge. */
export const GANTT_TOOLTIP_VIEWPORT_PAD = 8;

export function clampGanttTooltipPosition(opts: {
  cursorX: number;
  cursorY: number;
  width: number;
  height: number;
  viewportW: number;
  viewportH: number;
  offset?: number;
  pad?: number;
}): { left: number; top: number } {
  const offset = opts.offset ?? GANTT_TOOLTIP_CURSOR_OFFSET;
  const pad = opts.pad ?? GANTT_TOOLTIP_VIEWPORT_PAD;
  const { cursorX, cursorY, width, height, viewportW, viewportH } = opts;

  let left = cursorX + offset;
  if (left + width + pad > viewportW) {
    left = cursorX - width - offset;
  }
  if (left < pad) left = pad;
  if (left + width + pad > viewportW) {
    left = Math.max(pad, viewportW - width - pad);
  }

  let top = cursorY + offset;
  if (top + height + pad > viewportH) {
    top = cursorY - height - offset;
  }
  if (top < pad) top = pad;
  if (top + height + pad > viewportH) {
    top = Math.max(pad, viewportH - height - pad);
  }

  return { left, top };
}
